/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Zephyr
 * Zephyr API
 * OpenAPI spec version: 2.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type {
  AttachPaymentMethodParams,
  AttachPaymentMethodPathParameters,
  CancelDowngradePathParameters,
  ChangeSubscriptionPathParameters,
  ChangeSubscriptionRequest,
  CreateReleaseCandidateDefault,
  CreateReleaseCandidatePathParameters,
  CreateReleaseCandidateRequestDto,
  DeleteEnvironmentVariableDefault,
  DeleteEnvironmentVariablePathParameters,
  DeleteReleaseCandidateDefault,
  DeleteReleaseCandidatePathParameters,
  DeployTagToEnvironmentPathParameters,
  DeployTagToEnvironmentRequestDto,
  DetachPaymentMethodParams,
  DetachPaymentMethodPathParameters,
  EnvironmentVariableDto,
  GetCoupon200,
  GetCouponPathParameters,
  GetDefaultPaymentMethod200,
  GetDefaultPaymentMethodPathParameters,
  GetEnvVarsByRemoteHost200,
  GetEnvVarsByRemoteHostParams,
  GetEnvironmentVariableHistoryDefault,
  GetEnvironmentVariableHistoryPathParameters,
  GetEnvironmentVariablesPathParameters,
  GetReleasePipelineByApplicationListDefault,
  GetReleasePipelineByApplicationListParams,
  GetReleasePipelineByApplicationListPathParameters,
  GetReleasePipelineByOrgListDefault,
  GetReleasePipelineByOrgListParams,
  GetReleasePipelineByOrgListPathParameters,
  GetReleasePipelineByProjectListDefault,
  GetReleasePipelineByProjectListParams,
  GetReleasePipelineByProjectListPathParameters,
  GetReleasePipelineEnvironmentListPathParameters,
  GetReleasePipelineTagListParams,
  GetReleasePipelineTagListPathParameters,
  GetStripeSubscriptionItemsPathParameters,
  GetSubscriptionPathParameters,
  GetUpcomingInvoicePathParameters,
  GraphCurrentUsagePathParameters,
  GraphMetricBodyDto,
  GraphMetricResultDto,
  InvitePeopleDefault,
  InvitePeoplePathParameters,
  ListCurrentMetricUsagePathParameters,
  ListCurrentUsagePathParameters,
  ListInvoicesParams,
  ListInvoicesPathParameters,
  ListPaymentMethodsParams,
  ListPaymentMethodsPathParameters,
  ListQuotasPathParameters,
  NewPeopleDto,
  ReleasePipelineEnvironmentDto,
  ReleasePipelineTagDto,
  SetDefaultPaymentMethodParams,
  SetDefaultPaymentMethodPathParameters,
  SetEnvironmentOrderDefault,
  SetEnvironmentOrderPathParameters,
  SetEnvironmentVariableDefault,
  SetEnvironmentVariablePathParameters,
  SetEnvironmentVariableRequestDto,
  SimpleMetricQuotaDto,
  StripeInvoiceDto,
  StripePaymentMethodDto,
  StripePriceDto,
  StripeSubscriptionItemDto,
  StripeUpcomingInvoiceDto,
  SubscriptionWithQuotasAndCouponDto,
  UnsetEnvironmentVariableDefault,
  UnsetEnvironmentVariablePathParameters,
  UnsetEnvironmentVariableRequestDto,
  UpdateNonRecurringQuotaBody,
  UpdateNonRecurringQuotaPathParameters,
  UpdateRecurringQuotaBody,
  UpdateRecurringQuotaPathParameters,
  UsageQuotaDto,
  UsagesQuotaDto,
} from './zephyr.schemas';
import client from '../utils/mutator';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const getCoupon = (
  { coupon }: GetCouponPathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<GetCoupon200>(
    { url: `/v3/subscriptions/coupons/${encodeURIComponent(String(coupon))}`, method: 'GET', signal },
    options,
  );
};

export const getGetCouponQueryKey = ({ coupon }: GetCouponPathParameters) => {
  return [`/v3/subscriptions/coupons/${coupon}`] as const;
};

export const getGetCouponQueryOptions = <TData = Awaited<ReturnType<typeof getCoupon>>, TError = unknown>(
  { coupon }: GetCouponPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCouponQueryKey({ coupon });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoupon>>> = ({ signal }) =>
    getCoupon({ coupon }, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!coupon, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCoupon>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCouponQueryResult = NonNullable<Awaited<ReturnType<typeof getCoupon>>>;
export type GetCouponQueryError = unknown;

export function useGetCoupon<TData = Awaited<ReturnType<typeof getCoupon>>, TError = unknown>(
  { coupon }: GetCouponPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCouponQueryOptions({ coupon }, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCouponSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCoupon>>, TError = unknown>(
  { coupon }: GetCouponPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCouponQueryKey({ coupon });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoupon>>> = ({ signal }) =>
    getCoupon({ coupon }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getCoupon>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCouponSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCoupon>>>;
export type GetCouponSuspenseQueryError = unknown;

export function useGetCouponSuspense<TData = Awaited<ReturnType<typeof getCoupon>>, TError = unknown>(
  { coupon }: GetCouponPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCouponSuspenseQueryOptions({ coupon }, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listInvoices = (
  { organizationName }: ListInvoicesPathParameters,
  params?: ListInvoicesParams,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<StripeInvoiceDto[]>(
    {
      url: `/v3/subscriptions/invoices/${encodeURIComponent(String(organizationName))}/invoices`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getListInvoicesQueryKey = (
  { organizationName }: ListInvoicesPathParameters,
  params?: ListInvoicesParams,
) => {
  return [`/v3/subscriptions/invoices/${organizationName}/invoices`, ...(params ? [params] : [])] as const;
};

export const getListInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
  { organizationName }: ListInvoicesPathParameters,
  params?: ListInvoicesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInvoicesQueryKey({ organizationName }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoices>>> = ({ signal }) =>
    listInvoices({ organizationName }, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!organizationName, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoices>>>;
export type ListInvoicesQueryError = unknown;

export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
  { organizationName }: ListInvoicesPathParameters,
  params?: ListInvoicesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInvoicesQueryOptions({ organizationName }, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListInvoicesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
  { organizationName }: ListInvoicesPathParameters,
  params?: ListInvoicesParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInvoicesQueryKey({ organizationName }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoices>>> = ({ signal }) =>
    listInvoices({ organizationName }, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvoicesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoices>>>;
export type ListInvoicesSuspenseQueryError = unknown;

export function useListInvoicesSuspense<TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
  { organizationName }: ListInvoicesPathParameters,
  params?: ListInvoicesParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInvoicesSuspenseQueryOptions({ organizationName }, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUpcomingInvoice = (
  { organizationName }: GetUpcomingInvoicePathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<StripeUpcomingInvoiceDto>(
    {
      url: `/v3/subscriptions/invoices/${encodeURIComponent(String(organizationName))}/invoices/upcoming`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetUpcomingInvoiceQueryKey = ({ organizationName }: GetUpcomingInvoicePathParameters) => {
  return [`/v3/subscriptions/invoices/${organizationName}/invoices/upcoming`] as const;
};

export const getGetUpcomingInvoiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpcomingInvoice>>,
  TError = unknown,
>(
  { organizationName }: GetUpcomingInvoicePathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUpcomingInvoice>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUpcomingInvoiceQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpcomingInvoice>>> = ({ signal }) =>
    getUpcomingInvoice({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!organizationName, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUpcomingInvoice>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUpcomingInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getUpcomingInvoice>>>;
export type GetUpcomingInvoiceQueryError = unknown;

export function useGetUpcomingInvoice<TData = Awaited<ReturnType<typeof getUpcomingInvoice>>, TError = unknown>(
  { organizationName }: GetUpcomingInvoicePathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUpcomingInvoice>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUpcomingInvoiceQueryOptions({ organizationName }, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetUpcomingInvoiceSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpcomingInvoice>>,
  TError = unknown,
>(
  { organizationName }: GetUpcomingInvoicePathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpcomingInvoice>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUpcomingInvoiceQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpcomingInvoice>>> = ({ signal }) =>
    getUpcomingInvoice({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getUpcomingInvoice>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUpcomingInvoiceSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUpcomingInvoice>>>;
export type GetUpcomingInvoiceSuspenseQueryError = unknown;

export function useGetUpcomingInvoiceSuspense<TData = Awaited<ReturnType<typeof getUpcomingInvoice>>, TError = unknown>(
  { organizationName }: GetUpcomingInvoicePathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpcomingInvoice>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUpcomingInvoiceSuspenseQueryOptions({ organizationName }, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listCurrentUsage = (
  { organizationName }: ListCurrentUsagePathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<UsagesQuotaDto[]>(
    {
      url: `/v3/subscriptions/metrics/${encodeURIComponent(String(organizationName))}/current-usage`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getListCurrentUsageQueryKey = ({ organizationName }: ListCurrentUsagePathParameters) => {
  return [`/v3/subscriptions/metrics/${organizationName}/current-usage`] as const;
};

export const getListCurrentUsageQueryOptions = <TData = Awaited<ReturnType<typeof listCurrentUsage>>, TError = unknown>(
  { organizationName }: ListCurrentUsagePathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listCurrentUsage>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCurrentUsageQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurrentUsage>>> = ({ signal }) =>
    listCurrentUsage({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!organizationName, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCurrentUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCurrentUsageQueryResult = NonNullable<Awaited<ReturnType<typeof listCurrentUsage>>>;
export type ListCurrentUsageQueryError = unknown;

export function useListCurrentUsage<TData = Awaited<ReturnType<typeof listCurrentUsage>>, TError = unknown>(
  { organizationName }: ListCurrentUsagePathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listCurrentUsage>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCurrentUsageQueryOptions({ organizationName }, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListCurrentUsageSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listCurrentUsage>>,
  TError = unknown,
>(
  { organizationName }: ListCurrentUsagePathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCurrentUsage>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCurrentUsageQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurrentUsage>>> = ({ signal }) =>
    listCurrentUsage({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listCurrentUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCurrentUsageSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listCurrentUsage>>>;
export type ListCurrentUsageSuspenseQueryError = unknown;

export function useListCurrentUsageSuspense<TData = Awaited<ReturnType<typeof listCurrentUsage>>, TError = unknown>(
  { organizationName }: ListCurrentUsagePathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCurrentUsage>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCurrentUsageSuspenseQueryOptions({ organizationName }, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listCurrentMetricUsage = (
  { organizationName, metric }: ListCurrentMetricUsagePathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<UsageQuotaDto>(
    {
      url: `/v3/subscriptions/metrics/${encodeURIComponent(String(organizationName))}/current-usage/${encodeURIComponent(String(metric))}`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getListCurrentMetricUsageQueryKey = ({
  organizationName,
  metric,
}: ListCurrentMetricUsagePathParameters) => {
  return [`/v3/subscriptions/metrics/${organizationName}/current-usage/${metric}`] as const;
};

export const getListCurrentMetricUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof listCurrentMetricUsage>>,
  TError = unknown,
>(
  { organizationName, metric }: ListCurrentMetricUsagePathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listCurrentMetricUsage>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCurrentMetricUsageQueryKey({ organizationName, metric });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurrentMetricUsage>>> = ({ signal }) =>
    listCurrentMetricUsage({ organizationName, metric }, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(organizationName && metric), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCurrentMetricUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCurrentMetricUsageQueryResult = NonNullable<Awaited<ReturnType<typeof listCurrentMetricUsage>>>;
export type ListCurrentMetricUsageQueryError = unknown;

export function useListCurrentMetricUsage<TData = Awaited<ReturnType<typeof listCurrentMetricUsage>>, TError = unknown>(
  { organizationName, metric }: ListCurrentMetricUsagePathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listCurrentMetricUsage>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCurrentMetricUsageQueryOptions({ organizationName, metric }, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListCurrentMetricUsageSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listCurrentMetricUsage>>,
  TError = unknown,
>(
  { organizationName, metric }: ListCurrentMetricUsagePathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCurrentMetricUsage>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCurrentMetricUsageQueryKey({ organizationName, metric });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurrentMetricUsage>>> = ({ signal }) =>
    listCurrentMetricUsage({ organizationName, metric }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listCurrentMetricUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCurrentMetricUsageSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listCurrentMetricUsage>>>;
export type ListCurrentMetricUsageSuspenseQueryError = unknown;

export function useListCurrentMetricUsageSuspense<
  TData = Awaited<ReturnType<typeof listCurrentMetricUsage>>,
  TError = unknown,
>(
  { organizationName, metric }: ListCurrentMetricUsagePathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listCurrentMetricUsage>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCurrentMetricUsageSuspenseQueryOptions({ organizationName, metric }, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const graphCurrentUsage = (
  { organizationName }: GraphCurrentUsagePathParameters,
  graphMetricBodyDto: GraphMetricBodyDto,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<GraphMetricResultDto[]>(
    {
      url: `/v3/subscriptions/metrics/${encodeURIComponent(String(organizationName))}/current-usage-graph`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: graphMetricBodyDto,
      signal,
    },
    options,
  );
};

export const getGraphCurrentUsageMutationOptions = <
  TData = Awaited<ReturnType<typeof graphCurrentUsage>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: GraphCurrentUsagePathParameters; data: GraphMetricBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['graphCurrentUsage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof graphCurrentUsage>>,
    { pathParams: GraphCurrentUsagePathParameters; data: GraphMetricBodyDto }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return graphCurrentUsage(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: GraphCurrentUsagePathParameters; data: GraphMetricBodyDto },
    TContext
  >;
};

export type GraphCurrentUsageMutationResult = NonNullable<Awaited<ReturnType<typeof graphCurrentUsage>>>;
export type GraphCurrentUsageMutationBody = GraphMetricBodyDto;
export type GraphCurrentUsageMutationError = unknown;

export const useGraphCurrentUsage = <
  TData = Awaited<ReturnType<typeof graphCurrentUsage>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: GraphCurrentUsagePathParameters; data: GraphMetricBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: GraphCurrentUsagePathParameters; data: GraphMetricBodyDto },
  TContext
> => {
  const mutationOptions = getGraphCurrentUsageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listPaymentMethods = (
  { organizationName }: ListPaymentMethodsPathParameters,
  params?: ListPaymentMethodsParams,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<StripePaymentMethodDto[]>(
    {
      url: `/v3/subscriptions/payment-methods/${encodeURIComponent(String(organizationName))}`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getListPaymentMethodsQueryKey = (
  { organizationName }: ListPaymentMethodsPathParameters,
  params?: ListPaymentMethodsParams,
) => {
  return [`/v3/subscriptions/payment-methods/${organizationName}`, ...(params ? [params] : [])] as const;
};

export const getListPaymentMethodsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPaymentMethods>>,
  TError = unknown,
>(
  { organizationName }: ListPaymentMethodsPathParameters,
  params?: ListPaymentMethodsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPaymentMethodsQueryKey({ organizationName }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPaymentMethods>>> = ({ signal }) =>
    listPaymentMethods({ organizationName }, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!organizationName, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPaymentMethods>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPaymentMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof listPaymentMethods>>>;
export type ListPaymentMethodsQueryError = unknown;

export function useListPaymentMethods<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>(
  { organizationName }: ListPaymentMethodsPathParameters,
  params?: ListPaymentMethodsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPaymentMethodsQueryOptions({ organizationName }, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListPaymentMethodsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listPaymentMethods>>,
  TError = unknown,
>(
  { organizationName }: ListPaymentMethodsPathParameters,
  params?: ListPaymentMethodsParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPaymentMethodsQueryKey({ organizationName }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPaymentMethods>>> = ({ signal }) =>
    listPaymentMethods({ organizationName }, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listPaymentMethods>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPaymentMethodsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPaymentMethods>>>;
export type ListPaymentMethodsSuspenseQueryError = unknown;

export function useListPaymentMethodsSuspense<TData = Awaited<ReturnType<typeof listPaymentMethods>>, TError = unknown>(
  { organizationName }: ListPaymentMethodsPathParameters,
  params?: ListPaymentMethodsParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPaymentMethods>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPaymentMethodsSuspenseQueryOptions({ organizationName }, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const attachPaymentMethod = (
  { organizationName }: AttachPaymentMethodPathParameters,
  params: AttachPaymentMethodParams,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<boolean>(
    {
      url: `/v3/subscriptions/payment-methods/${encodeURIComponent(String(organizationName))}/attach`,
      method: 'POST',
      params,
      signal,
    },
    options,
  );
};

export const getAttachPaymentMethodMutationOptions = <
  TData = Awaited<ReturnType<typeof attachPaymentMethod>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: AttachPaymentMethodPathParameters; params: AttachPaymentMethodParams },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['attachPaymentMethod'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attachPaymentMethod>>,
    { pathParams: AttachPaymentMethodPathParameters; params: AttachPaymentMethodParams }
  > = (props) => {
    const { pathParams, params } = props ?? {};

    return attachPaymentMethod(pathParams, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: AttachPaymentMethodPathParameters; params: AttachPaymentMethodParams },
    TContext
  >;
};

export type AttachPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof attachPaymentMethod>>>;

export type AttachPaymentMethodMutationError = unknown;

export const useAttachPaymentMethod = <
  TData = Awaited<ReturnType<typeof attachPaymentMethod>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: AttachPaymentMethodPathParameters; params: AttachPaymentMethodParams },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: AttachPaymentMethodPathParameters; params: AttachPaymentMethodParams },
  TContext
> => {
  const mutationOptions = getAttachPaymentMethodMutationOptions(options);

  return useMutation(mutationOptions);
};

export const detachPaymentMethod = (
  { organizationName }: DetachPaymentMethodPathParameters,
  params: DetachPaymentMethodParams,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<boolean>(
    {
      url: `/v3/subscriptions/payment-methods/${encodeURIComponent(String(organizationName))}/detach`,
      method: 'POST',
      params,
      signal,
    },
    options,
  );
};

export const getDetachPaymentMethodMutationOptions = <
  TData = Awaited<ReturnType<typeof detachPaymentMethod>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: DetachPaymentMethodPathParameters; params: DetachPaymentMethodParams },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['detachPaymentMethod'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof detachPaymentMethod>>,
    { pathParams: DetachPaymentMethodPathParameters; params: DetachPaymentMethodParams }
  > = (props) => {
    const { pathParams, params } = props ?? {};

    return detachPaymentMethod(pathParams, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: DetachPaymentMethodPathParameters; params: DetachPaymentMethodParams },
    TContext
  >;
};

export type DetachPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof detachPaymentMethod>>>;

export type DetachPaymentMethodMutationError = unknown;

export const useDetachPaymentMethod = <
  TData = Awaited<ReturnType<typeof detachPaymentMethod>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: DetachPaymentMethodPathParameters; params: DetachPaymentMethodParams },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: DetachPaymentMethodPathParameters; params: DetachPaymentMethodParams },
  TContext
> => {
  const mutationOptions = getDetachPaymentMethodMutationOptions(options);

  return useMutation(mutationOptions);
};

export const setDefaultPaymentMethod = (
  { organizationName }: SetDefaultPaymentMethodPathParameters,
  params: SetDefaultPaymentMethodParams,
  options?: SecondParameter<typeof client>,
) => {
  return client<boolean>(
    {
      url: `/v3/subscriptions/payment-methods/${encodeURIComponent(String(organizationName))}/default`,
      method: 'PUT',
      params,
    },
    options,
  );
};

export const getSetDefaultPaymentMethodMutationOptions = <
  TData = Awaited<ReturnType<typeof setDefaultPaymentMethod>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: SetDefaultPaymentMethodPathParameters; params: SetDefaultPaymentMethodParams },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['setDefaultPaymentMethod'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setDefaultPaymentMethod>>,
    { pathParams: SetDefaultPaymentMethodPathParameters; params: SetDefaultPaymentMethodParams }
  > = (props) => {
    const { pathParams, params } = props ?? {};

    return setDefaultPaymentMethod(pathParams, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: SetDefaultPaymentMethodPathParameters; params: SetDefaultPaymentMethodParams },
    TContext
  >;
};

export type SetDefaultPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultPaymentMethod>>>;

export type SetDefaultPaymentMethodMutationError = unknown;

export const useSetDefaultPaymentMethod = <
  TData = Awaited<ReturnType<typeof setDefaultPaymentMethod>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: SetDefaultPaymentMethodPathParameters; params: SetDefaultPaymentMethodParams },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: SetDefaultPaymentMethodPathParameters; params: SetDefaultPaymentMethodParams },
  TContext
> => {
  const mutationOptions = getSetDefaultPaymentMethodMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getDefaultPaymentMethod = (
  { organizationName }: GetDefaultPaymentMethodPathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<GetDefaultPaymentMethod200>(
    {
      url: `/v3/subscriptions/payment-methods/${encodeURIComponent(String(organizationName))}/default`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetDefaultPaymentMethodQueryKey = ({ organizationName }: GetDefaultPaymentMethodPathParameters) => {
  return [`/v3/subscriptions/payment-methods/${organizationName}/default`] as const;
};

export const getGetDefaultPaymentMethodQueryOptions = <
  TData = Awaited<ReturnType<typeof getDefaultPaymentMethod>>,
  TError = unknown,
>(
  { organizationName }: GetDefaultPaymentMethodPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDefaultPaymentMethod>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDefaultPaymentMethodQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultPaymentMethod>>> = ({ signal }) =>
    getDefaultPaymentMethod({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!organizationName, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDefaultPaymentMethod>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDefaultPaymentMethodQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultPaymentMethod>>>;
export type GetDefaultPaymentMethodQueryError = unknown;

export function useGetDefaultPaymentMethod<
  TData = Awaited<ReturnType<typeof getDefaultPaymentMethod>>,
  TError = unknown,
>(
  { organizationName }: GetDefaultPaymentMethodPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDefaultPaymentMethod>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDefaultPaymentMethodQueryOptions({ organizationName }, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDefaultPaymentMethodSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getDefaultPaymentMethod>>,
  TError = unknown,
>(
  { organizationName }: GetDefaultPaymentMethodPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefaultPaymentMethod>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDefaultPaymentMethodQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultPaymentMethod>>> = ({ signal }) =>
    getDefaultPaymentMethod({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDefaultPaymentMethod>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDefaultPaymentMethodSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDefaultPaymentMethod>>
>;
export type GetDefaultPaymentMethodSuspenseQueryError = unknown;

export function useGetDefaultPaymentMethodSuspense<
  TData = Awaited<ReturnType<typeof getDefaultPaymentMethod>>,
  TError = unknown,
>(
  { organizationName }: GetDefaultPaymentMethodPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefaultPaymentMethod>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDefaultPaymentMethodSuspenseQueryOptions({ organizationName }, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listQuotas = (
  { organizationName }: ListQuotasPathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<SimpleMetricQuotaDto[]>(
    { url: `/v3/subscriptions/quotas/${encodeURIComponent(String(organizationName))}`, method: 'GET', signal },
    options,
  );
};

export const getListQuotasQueryKey = ({ organizationName }: ListQuotasPathParameters) => {
  return [`/v3/subscriptions/quotas/${organizationName}`] as const;
};

export const getListQuotasQueryOptions = <TData = Awaited<ReturnType<typeof listQuotas>>, TError = unknown>(
  { organizationName }: ListQuotasPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listQuotas>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListQuotasQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotas>>> = ({ signal }) =>
    listQuotas({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!organizationName, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listQuotas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListQuotasQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotas>>>;
export type ListQuotasQueryError = unknown;

export function useListQuotas<TData = Awaited<ReturnType<typeof listQuotas>>, TError = unknown>(
  { organizationName }: ListQuotasPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listQuotas>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListQuotasQueryOptions({ organizationName }, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListQuotasSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listQuotas>>, TError = unknown>(
  { organizationName }: ListQuotasPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotas>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListQuotasQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuotas>>> = ({ signal }) =>
    listQuotas({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listQuotas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListQuotasSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listQuotas>>>;
export type ListQuotasSuspenseQueryError = unknown;

export function useListQuotasSuspense<TData = Awaited<ReturnType<typeof listQuotas>>, TError = unknown>(
  { organizationName }: ListQuotasPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listQuotas>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListQuotasSuspenseQueryOptions({ organizationName }, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateRecurringQuota = (
  { organizationName, metric }: UpdateRecurringQuotaPathParameters,
  updateRecurringQuotaBody: UpdateRecurringQuotaBody,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<boolean>(
    {
      url: `/v3/subscriptions/quotas/${encodeURIComponent(String(organizationName))}/${encodeURIComponent(String(metric))}/recurring`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: updateRecurringQuotaBody,
      signal,
    },
    options,
  );
};

export const getUpdateRecurringQuotaMutationOptions = <
  TData = Awaited<ReturnType<typeof updateRecurringQuota>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: UpdateRecurringQuotaPathParameters; data: UpdateRecurringQuotaBody },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['updateRecurringQuota'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRecurringQuota>>,
    { pathParams: UpdateRecurringQuotaPathParameters; data: UpdateRecurringQuotaBody }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return updateRecurringQuota(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: UpdateRecurringQuotaPathParameters; data: UpdateRecurringQuotaBody },
    TContext
  >;
};

export type UpdateRecurringQuotaMutationResult = NonNullable<Awaited<ReturnType<typeof updateRecurringQuota>>>;
export type UpdateRecurringQuotaMutationBody = UpdateRecurringQuotaBody;
export type UpdateRecurringQuotaMutationError = unknown;

export const useUpdateRecurringQuota = <
  TData = Awaited<ReturnType<typeof updateRecurringQuota>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: UpdateRecurringQuotaPathParameters; data: UpdateRecurringQuotaBody },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: UpdateRecurringQuotaPathParameters; data: UpdateRecurringQuotaBody },
  TContext
> => {
  const mutationOptions = getUpdateRecurringQuotaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateNonRecurringQuota = (
  { organizationName, metric }: UpdateNonRecurringQuotaPathParameters,
  updateNonRecurringQuotaBody: UpdateNonRecurringQuotaBody,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<boolean>(
    {
      url: `/v3/subscriptions/quotas/${encodeURIComponent(String(organizationName))}/${encodeURIComponent(String(metric))}/non-recurring`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: updateNonRecurringQuotaBody,
      signal,
    },
    options,
  );
};

export const getUpdateNonRecurringQuotaMutationOptions = <
  TData = Awaited<ReturnType<typeof updateNonRecurringQuota>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: UpdateNonRecurringQuotaPathParameters; data: UpdateNonRecurringQuotaBody },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['updateNonRecurringQuota'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNonRecurringQuota>>,
    { pathParams: UpdateNonRecurringQuotaPathParameters; data: UpdateNonRecurringQuotaBody }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return updateNonRecurringQuota(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: UpdateNonRecurringQuotaPathParameters; data: UpdateNonRecurringQuotaBody },
    TContext
  >;
};

export type UpdateNonRecurringQuotaMutationResult = NonNullable<Awaited<ReturnType<typeof updateNonRecurringQuota>>>;
export type UpdateNonRecurringQuotaMutationBody = UpdateNonRecurringQuotaBody;
export type UpdateNonRecurringQuotaMutationError = unknown;

export const useUpdateNonRecurringQuota = <
  TData = Awaited<ReturnType<typeof updateNonRecurringQuota>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: UpdateNonRecurringQuotaPathParameters; data: UpdateNonRecurringQuotaBody },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: UpdateNonRecurringQuotaPathParameters; data: UpdateNonRecurringQuotaBody },
  TContext
> => {
  const mutationOptions = getUpdateNonRecurringQuotaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listAllStripePrices = (options?: SecondParameter<typeof client>, signal?: AbortSignal) => {
  return client<StripePriceDto[]>({ url: `/v3/subscriptions/stripe/prices/all`, method: 'GET', signal }, options);
};

export const getListAllStripePricesQueryKey = () => {
  return [`/v3/subscriptions/stripe/prices/all`] as const;
};

export const getListAllStripePricesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllStripePrices>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listAllStripePrices>>, TError, TData>;
  request?: SecondParameter<typeof client>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllStripePricesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllStripePrices>>> = ({ signal }) =>
    listAllStripePrices(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllStripePrices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAllStripePricesQueryResult = NonNullable<Awaited<ReturnType<typeof listAllStripePrices>>>;
export type ListAllStripePricesQueryError = unknown;

export function useListAllStripePrices<
  TData = Awaited<ReturnType<typeof listAllStripePrices>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listAllStripePrices>>, TError, TData>;
  request?: SecondParameter<typeof client>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAllStripePricesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListAllStripePricesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllStripePrices>>,
  TError = unknown,
>(options?: {
  query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAllStripePrices>>, TError, TData>;
  request?: SecondParameter<typeof client>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllStripePricesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllStripePrices>>> = ({ signal }) =>
    listAllStripePrices(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listAllStripePrices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAllStripePricesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAllStripePrices>>>;
export type ListAllStripePricesSuspenseQueryError = unknown;

export function useListAllStripePricesSuspense<
  TData = Awaited<ReturnType<typeof listAllStripePrices>>,
  TError = unknown,
>(options?: {
  query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAllStripePrices>>, TError, TData>;
  request?: SecondParameter<typeof client>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAllStripePricesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStripeSubscriptionItems = (
  { organizationName }: GetStripeSubscriptionItemsPathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<StripeSubscriptionItemDto[]>(
    {
      url: `/v3/subscriptions/stripe/subscription/${encodeURIComponent(String(organizationName))}/items`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetStripeSubscriptionItemsQueryKey = ({
  organizationName,
}: GetStripeSubscriptionItemsPathParameters) => {
  return [`/v3/subscriptions/stripe/subscription/${organizationName}/items`] as const;
};

export const getGetStripeSubscriptionItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStripeSubscriptionItems>>,
  TError = unknown,
>(
  { organizationName }: GetStripeSubscriptionItemsPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getStripeSubscriptionItems>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStripeSubscriptionItemsQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStripeSubscriptionItems>>> = ({ signal }) =>
    getStripeSubscriptionItems({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!organizationName, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStripeSubscriptionItems>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStripeSubscriptionItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getStripeSubscriptionItems>>>;
export type GetStripeSubscriptionItemsQueryError = unknown;

export function useGetStripeSubscriptionItems<
  TData = Awaited<ReturnType<typeof getStripeSubscriptionItems>>,
  TError = unknown,
>(
  { organizationName }: GetStripeSubscriptionItemsPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getStripeSubscriptionItems>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStripeSubscriptionItemsQueryOptions({ organizationName }, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetStripeSubscriptionItemsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getStripeSubscriptionItems>>,
  TError = unknown,
>(
  { organizationName }: GetStripeSubscriptionItemsPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStripeSubscriptionItems>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStripeSubscriptionItemsQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStripeSubscriptionItems>>> = ({ signal }) =>
    getStripeSubscriptionItems({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getStripeSubscriptionItems>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStripeSubscriptionItemsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStripeSubscriptionItems>>
>;
export type GetStripeSubscriptionItemsSuspenseQueryError = unknown;

export function useGetStripeSubscriptionItemsSuspense<
  TData = Awaited<ReturnType<typeof getStripeSubscriptionItems>>,
  TError = unknown,
>(
  { organizationName }: GetStripeSubscriptionItemsPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStripeSubscriptionItems>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStripeSubscriptionItemsSuspenseQueryOptions({ organizationName }, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSubscription = (
  { organizationName }: GetSubscriptionPathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<SubscriptionWithQuotasAndCouponDto>(
    { url: `/v3/subscriptions/${encodeURIComponent(String(organizationName))}`, method: 'GET', signal },
    options,
  );
};

export const getGetSubscriptionQueryKey = ({ organizationName }: GetSubscriptionPathParameters) => {
  return [`/v3/subscriptions/${organizationName}`] as const;
};

export const getGetSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  { organizationName }: GetSubscriptionPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubscriptionQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscription>>> = ({ signal }) =>
    getSubscription({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!organizationName, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubscription>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscription>>>;
export type GetSubscriptionQueryError = unknown;

export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  { organizationName }: GetSubscriptionPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSubscriptionQueryOptions({ organizationName }, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSubscriptionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubscription>>,
  TError = unknown,
>(
  { organizationName }: GetSubscriptionPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubscriptionQueryKey({ organizationName });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscription>>> = ({ signal }) =>
    getSubscription({ organizationName }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSubscription>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSubscriptionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscription>>>;
export type GetSubscriptionSuspenseQueryError = unknown;

export function useGetSubscriptionSuspense<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  { organizationName }: GetSubscriptionPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSubscriptionSuspenseQueryOptions({ organizationName }, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const changeSubscription = (
  { organizationName }: ChangeSubscriptionPathParameters,
  changeSubscriptionRequest: ChangeSubscriptionRequest,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<boolean>(
    {
      url: `/v3/subscriptions/${encodeURIComponent(String(organizationName))}/change`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: changeSubscriptionRequest,
      signal,
    },
    options,
  );
};

export const getChangeSubscriptionMutationOptions = <
  TData = Awaited<ReturnType<typeof changeSubscription>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: ChangeSubscriptionPathParameters; data: ChangeSubscriptionRequest },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['changeSubscription'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeSubscription>>,
    { pathParams: ChangeSubscriptionPathParameters; data: ChangeSubscriptionRequest }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return changeSubscription(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: ChangeSubscriptionPathParameters; data: ChangeSubscriptionRequest },
    TContext
  >;
};

export type ChangeSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof changeSubscription>>>;
export type ChangeSubscriptionMutationBody = ChangeSubscriptionRequest;
export type ChangeSubscriptionMutationError = unknown;

export const useChangeSubscription = <
  TData = Awaited<ReturnType<typeof changeSubscription>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: ChangeSubscriptionPathParameters; data: ChangeSubscriptionRequest },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: ChangeSubscriptionPathParameters; data: ChangeSubscriptionRequest },
  TContext
> => {
  const mutationOptions = getChangeSubscriptionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cancelDowngrade = (
  { organizationName }: CancelDowngradePathParameters,
  options?: SecondParameter<typeof client>,
) => {
  return client<boolean>(
    { url: `/v3/subscriptions/${encodeURIComponent(String(organizationName))}/downgrade`, method: 'DELETE' },
    options,
  );
};

export const getCancelDowngradeMutationOptions = <
  TData = Awaited<ReturnType<typeof cancelDowngrade>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { pathParams: CancelDowngradePathParameters }, TContext>;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['cancelDowngrade'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelDowngrade>>,
    { pathParams: CancelDowngradePathParameters }
  > = (props) => {
    const { pathParams } = props ?? {};

    return cancelDowngrade(pathParams, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: CancelDowngradePathParameters },
    TContext
  >;
};

export type CancelDowngradeMutationResult = NonNullable<Awaited<ReturnType<typeof cancelDowngrade>>>;

export type CancelDowngradeMutationError = unknown;

export const useCancelDowngrade = <
  TData = Awaited<ReturnType<typeof cancelDowngrade>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { pathParams: CancelDowngradePathParameters }, TContext>;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<TData, TError, { pathParams: CancelDowngradePathParameters }, TContext> => {
  const mutationOptions = getCancelDowngradeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const invitePeople = (
  { organizationName }: InvitePeoplePathParameters,
  newPeopleDto: NewPeopleDto,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    {
      url: `/v2/organization/${encodeURIComponent(String(organizationName))}/invite`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: newPeopleDto,
      signal,
    },
    options,
  );
};

export const getInvitePeopleMutationOptions = <
  TData = Awaited<ReturnType<typeof invitePeople>>,
  TError = InvitePeopleDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: InvitePeoplePathParameters; data: NewPeopleDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['invitePeople'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invitePeople>>,
    { pathParams: InvitePeoplePathParameters; data: NewPeopleDto }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return invitePeople(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: InvitePeoplePathParameters; data: NewPeopleDto },
    TContext
  >;
};

export type InvitePeopleMutationResult = NonNullable<Awaited<ReturnType<typeof invitePeople>>>;
export type InvitePeopleMutationBody = NewPeopleDto;
export type InvitePeopleMutationError = InvitePeopleDefault;

export const useInvitePeople = <
  TData = Awaited<ReturnType<typeof invitePeople>>,
  TError = InvitePeopleDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: InvitePeoplePathParameters; data: NewPeopleDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<TData, TError, { pathParams: InvitePeoplePathParameters; data: NewPeopleDto }, TContext> => {
  const mutationOptions = getInvitePeopleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get the release pipeline for an organization
 * @summary Get the release pipeline for an organization
 */
export const getReleasePipelineByOrgList = (
  { organization }: GetReleasePipelineByOrgListPathParameters,
  params: GetReleasePipelineByOrgListParams,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    { url: `/v2/pipeline/${encodeURIComponent(String(organization))}/list`, method: 'GET', params, signal },
    options,
  );
};

export const getGetReleasePipelineByOrgListQueryKey = (
  { organization }: GetReleasePipelineByOrgListPathParameters,
  params: GetReleasePipelineByOrgListParams,
) => {
  return [`/v2/pipeline/${organization}/list`, ...(params ? [params] : [])] as const;
};

export const getGetReleasePipelineByOrgListQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleasePipelineByOrgList>>,
  TError = GetReleasePipelineByOrgListDefault,
>(
  { organization }: GetReleasePipelineByOrgListPathParameters,
  params: GetReleasePipelineByOrgListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByOrgList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReleasePipelineByOrgListQueryKey({ organization }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePipelineByOrgList>>> = ({ signal }) =>
    getReleasePipelineByOrgList({ organization }, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!organization, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReleasePipelineByOrgList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReleasePipelineByOrgListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleasePipelineByOrgList>>
>;
export type GetReleasePipelineByOrgListQueryError = GetReleasePipelineByOrgListDefault;

/**
 * @summary Get the release pipeline for an organization
 */

export function useGetReleasePipelineByOrgList<
  TData = Awaited<ReturnType<typeof getReleasePipelineByOrgList>>,
  TError = GetReleasePipelineByOrgListDefault,
>(
  { organization }: GetReleasePipelineByOrgListPathParameters,
  params: GetReleasePipelineByOrgListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByOrgList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReleasePipelineByOrgListQueryOptions({ organization }, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReleasePipelineByOrgListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleasePipelineByOrgList>>,
  TError = GetReleasePipelineByOrgListDefault,
>(
  { organization }: GetReleasePipelineByOrgListPathParameters,
  params: GetReleasePipelineByOrgListParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByOrgList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReleasePipelineByOrgListQueryKey({ organization }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePipelineByOrgList>>> = ({ signal }) =>
    getReleasePipelineByOrgList({ organization }, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReleasePipelineByOrgList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReleasePipelineByOrgListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleasePipelineByOrgList>>
>;
export type GetReleasePipelineByOrgListSuspenseQueryError = GetReleasePipelineByOrgListDefault;

/**
 * @summary Get the release pipeline for an organization
 */

export function useGetReleasePipelineByOrgListSuspense<
  TData = Awaited<ReturnType<typeof getReleasePipelineByOrgList>>,
  TError = GetReleasePipelineByOrgListDefault,
>(
  { organization }: GetReleasePipelineByOrgListPathParameters,
  params: GetReleasePipelineByOrgListParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByOrgList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReleasePipelineByOrgListSuspenseQueryOptions({ organization }, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the release pipeline for a project
 * @summary Get the release pipeline for a project
 */
export const getReleasePipelineByProjectList = (
  { organization, project }: GetReleasePipelineByProjectListPathParameters,
  params: GetReleasePipelineByProjectListParams,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/list`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetReleasePipelineByProjectListQueryKey = (
  { organization, project }: GetReleasePipelineByProjectListPathParameters,
  params: GetReleasePipelineByProjectListParams,
) => {
  return [`/v2/pipeline/${organization}/${project}/list`, ...(params ? [params] : [])] as const;
};

export const getGetReleasePipelineByProjectListQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleasePipelineByProjectList>>,
  TError = GetReleasePipelineByProjectListDefault,
>(
  { organization, project }: GetReleasePipelineByProjectListPathParameters,
  params: GetReleasePipelineByProjectListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByProjectList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReleasePipelineByProjectListQueryKey({ organization, project }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePipelineByProjectList>>> = ({ signal }) =>
    getReleasePipelineByProjectList({ organization, project }, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(organization && project), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReleasePipelineByProjectList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReleasePipelineByProjectListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleasePipelineByProjectList>>
>;
export type GetReleasePipelineByProjectListQueryError = GetReleasePipelineByProjectListDefault;

/**
 * @summary Get the release pipeline for a project
 */

export function useGetReleasePipelineByProjectList<
  TData = Awaited<ReturnType<typeof getReleasePipelineByProjectList>>,
  TError = GetReleasePipelineByProjectListDefault,
>(
  { organization, project }: GetReleasePipelineByProjectListPathParameters,
  params: GetReleasePipelineByProjectListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByProjectList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReleasePipelineByProjectListQueryOptions({ organization, project }, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReleasePipelineByProjectListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleasePipelineByProjectList>>,
  TError = GetReleasePipelineByProjectListDefault,
>(
  { organization, project }: GetReleasePipelineByProjectListPathParameters,
  params: GetReleasePipelineByProjectListParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByProjectList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReleasePipelineByProjectListQueryKey({ organization, project }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePipelineByProjectList>>> = ({ signal }) =>
    getReleasePipelineByProjectList({ organization, project }, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReleasePipelineByProjectList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReleasePipelineByProjectListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleasePipelineByProjectList>>
>;
export type GetReleasePipelineByProjectListSuspenseQueryError = GetReleasePipelineByProjectListDefault;

/**
 * @summary Get the release pipeline for a project
 */

export function useGetReleasePipelineByProjectListSuspense<
  TData = Awaited<ReturnType<typeof getReleasePipelineByProjectList>>,
  TError = GetReleasePipelineByProjectListDefault,
>(
  { organization, project }: GetReleasePipelineByProjectListPathParameters,
  params: GetReleasePipelineByProjectListParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByProjectList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReleasePipelineByProjectListSuspenseQueryOptions(
    { organization, project },
    params,
    options,
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the release pipeline for an application
 * @summary Get the release pipeline for an application
 */
export const getReleasePipelineByApplicationList = (
  { organization, project, application }: GetReleasePipelineByApplicationListPathParameters,
  params: GetReleasePipelineByApplicationListParams,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/list`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetReleasePipelineByApplicationListQueryKey = (
  { organization, project, application }: GetReleasePipelineByApplicationListPathParameters,
  params: GetReleasePipelineByApplicationListParams,
) => {
  return [`/v2/pipeline/${organization}/${project}/${application}/list`, ...(params ? [params] : [])] as const;
};

export const getGetReleasePipelineByApplicationListQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>,
  TError = GetReleasePipelineByApplicationListDefault,
>(
  { organization, project, application }: GetReleasePipelineByApplicationListPathParameters,
  params: GetReleasePipelineByApplicationListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReleasePipelineByApplicationListQueryKey({ organization, project, application }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>> = ({ signal }) =>
    getReleasePipelineByApplicationList({ organization, project, application }, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(organization && project && application), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReleasePipelineByApplicationListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>
>;
export type GetReleasePipelineByApplicationListQueryError = GetReleasePipelineByApplicationListDefault;

/**
 * @summary Get the release pipeline for an application
 */

export function useGetReleasePipelineByApplicationList<
  TData = Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>,
  TError = GetReleasePipelineByApplicationListDefault,
>(
  { organization, project, application }: GetReleasePipelineByApplicationListPathParameters,
  params: GetReleasePipelineByApplicationListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReleasePipelineByApplicationListQueryOptions(
    { organization, project, application },
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReleasePipelineByApplicationListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>,
  TError = GetReleasePipelineByApplicationListDefault,
>(
  { organization, project, application }: GetReleasePipelineByApplicationListPathParameters,
  params: GetReleasePipelineByApplicationListParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReleasePipelineByApplicationListQueryKey({ organization, project, application }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>> = ({ signal }) =>
    getReleasePipelineByApplicationList({ organization, project, application }, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReleasePipelineByApplicationListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>
>;
export type GetReleasePipelineByApplicationListSuspenseQueryError = GetReleasePipelineByApplicationListDefault;

/**
 * @summary Get the release pipeline for an application
 */

export function useGetReleasePipelineByApplicationListSuspense<
  TData = Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>,
  TError = GetReleasePipelineByApplicationListDefault,
>(
  { organization, project, application }: GetReleasePipelineByApplicationListPathParameters,
  params: GetReleasePipelineByApplicationListParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineByApplicationList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReleasePipelineByApplicationListSuspenseQueryOptions(
    { organization, project, application },
    params,
    options,
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the release pipeline tag list for an application
 * @summary Get the release pipeline tag list for an application
 */
export const getReleasePipelineTagList = (
  { organization, project, application }: GetReleasePipelineTagListPathParameters,
  params?: GetReleasePipelineTagListParams,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<ReleasePipelineTagDto[]>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/tag-list`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetReleasePipelineTagListQueryKey = (
  { organization, project, application }: GetReleasePipelineTagListPathParameters,
  params?: GetReleasePipelineTagListParams,
) => {
  return [`/v2/pipeline/${organization}/${project}/${application}/tag-list`, ...(params ? [params] : [])] as const;
};

export const getGetReleasePipelineTagListQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleasePipelineTagList>>,
  TError = unknown,
>(
  { organization, project, application }: GetReleasePipelineTagListPathParameters,
  params?: GetReleasePipelineTagListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineTagList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReleasePipelineTagListQueryKey({ organization, project, application }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePipelineTagList>>> = ({ signal }) =>
    getReleasePipelineTagList({ organization, project, application }, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(organization && project && application), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReleasePipelineTagList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReleasePipelineTagListQueryResult = NonNullable<Awaited<ReturnType<typeof getReleasePipelineTagList>>>;
export type GetReleasePipelineTagListQueryError = unknown;

/**
 * @summary Get the release pipeline tag list for an application
 */

export function useGetReleasePipelineTagList<
  TData = Awaited<ReturnType<typeof getReleasePipelineTagList>>,
  TError = unknown,
>(
  { organization, project, application }: GetReleasePipelineTagListPathParameters,
  params?: GetReleasePipelineTagListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineTagList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReleasePipelineTagListQueryOptions(
    { organization, project, application },
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReleasePipelineTagListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleasePipelineTagList>>,
  TError = unknown,
>(
  { organization, project, application }: GetReleasePipelineTagListPathParameters,
  params?: GetReleasePipelineTagListParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineTagList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReleasePipelineTagListQueryKey({ organization, project, application }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePipelineTagList>>> = ({ signal }) =>
    getReleasePipelineTagList({ organization, project, application }, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReleasePipelineTagList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReleasePipelineTagListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleasePipelineTagList>>
>;
export type GetReleasePipelineTagListSuspenseQueryError = unknown;

/**
 * @summary Get the release pipeline tag list for an application
 */

export function useGetReleasePipelineTagListSuspense<
  TData = Awaited<ReturnType<typeof getReleasePipelineTagList>>,
  TError = unknown,
>(
  { organization, project, application }: GetReleasePipelineTagListPathParameters,
  params?: GetReleasePipelineTagListParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineTagList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReleasePipelineTagListSuspenseQueryOptions(
    { organization, project, application },
    params,
    options,
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the release pipeline environment list for an application
 * @summary Get the release pipeline environment list for an application
 */
export const getReleasePipelineEnvironmentList = (
  { organization, project, application }: GetReleasePipelineEnvironmentListPathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<ReleasePipelineEnvironmentDto[]>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/environment-list`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetReleasePipelineEnvironmentListQueryKey = ({
  organization,
  project,
  application,
}: GetReleasePipelineEnvironmentListPathParameters) => {
  return [`/v2/pipeline/${organization}/${project}/${application}/environment-list`] as const;
};

export const getGetReleasePipelineEnvironmentListQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>,
  TError = unknown,
>(
  { organization, project, application }: GetReleasePipelineEnvironmentListPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReleasePipelineEnvironmentListQueryKey({ organization, project, application });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>> = ({ signal }) =>
    getReleasePipelineEnvironmentList({ organization, project, application }, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(organization && project && application), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReleasePipelineEnvironmentListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>
>;
export type GetReleasePipelineEnvironmentListQueryError = unknown;

/**
 * @summary Get the release pipeline environment list for an application
 */

export function useGetReleasePipelineEnvironmentList<
  TData = Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>,
  TError = unknown,
>(
  { organization, project, application }: GetReleasePipelineEnvironmentListPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReleasePipelineEnvironmentListQueryOptions(
    { organization, project, application },
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReleasePipelineEnvironmentListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>,
  TError = unknown,
>(
  { organization, project, application }: GetReleasePipelineEnvironmentListPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReleasePipelineEnvironmentListQueryKey({ organization, project, application });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>> = ({ signal }) =>
    getReleasePipelineEnvironmentList({ organization, project, application }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReleasePipelineEnvironmentListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>
>;
export type GetReleasePipelineEnvironmentListSuspenseQueryError = unknown;

/**
 * @summary Get the release pipeline environment list for an application
 */

export function useGetReleasePipelineEnvironmentListSuspense<
  TData = Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>,
  TError = unknown,
>(
  { organization, project, application }: GetReleasePipelineEnvironmentListPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePipelineEnvironmentList>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReleasePipelineEnvironmentListSuspenseQueryOptions(
    { organization, project, application },
    options,
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a release candidate
 * @summary Create a release candidate
 */
export const createReleaseCandidate = (
  { organization, project, application }: CreateReleaseCandidatePathParameters,
  createReleaseCandidateRequestDto: CreateReleaseCandidateRequestDto,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<string>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/create-release-candidate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createReleaseCandidateRequestDto,
      signal,
    },
    options,
  );
};

export const getCreateReleaseCandidateMutationOptions = <
  TData = Awaited<ReturnType<typeof createReleaseCandidate>>,
  TError = CreateReleaseCandidateDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: CreateReleaseCandidatePathParameters; data: CreateReleaseCandidateRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['createReleaseCandidate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReleaseCandidate>>,
    { pathParams: CreateReleaseCandidatePathParameters; data: CreateReleaseCandidateRequestDto }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return createReleaseCandidate(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: CreateReleaseCandidatePathParameters; data: CreateReleaseCandidateRequestDto },
    TContext
  >;
};

export type CreateReleaseCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof createReleaseCandidate>>>;
export type CreateReleaseCandidateMutationBody = CreateReleaseCandidateRequestDto;
export type CreateReleaseCandidateMutationError = CreateReleaseCandidateDefault;

/**
 * @summary Create a release candidate
 */
export const useCreateReleaseCandidate = <
  TData = Awaited<ReturnType<typeof createReleaseCandidate>>,
  TError = CreateReleaseCandidateDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: CreateReleaseCandidatePathParameters; data: CreateReleaseCandidateRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: CreateReleaseCandidatePathParameters; data: CreateReleaseCandidateRequestDto },
  TContext
> => {
  const mutationOptions = getCreateReleaseCandidateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Deploy a tag to an environment
 * @summary Deploy a tag to an environment
 */
export const deployTagToEnvironment = (
  { organization, project, application }: DeployTagToEnvironmentPathParameters,
  deployTagToEnvironmentRequestDto: DeployTagToEnvironmentRequestDto,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/deploy-tag-to-environment`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: deployTagToEnvironmentRequestDto,
      signal,
    },
    options,
  );
};

export const getDeployTagToEnvironmentMutationOptions = <
  TData = Awaited<ReturnType<typeof deployTagToEnvironment>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: DeployTagToEnvironmentPathParameters; data: DeployTagToEnvironmentRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['deployTagToEnvironment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deployTagToEnvironment>>,
    { pathParams: DeployTagToEnvironmentPathParameters; data: DeployTagToEnvironmentRequestDto }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return deployTagToEnvironment(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: DeployTagToEnvironmentPathParameters; data: DeployTagToEnvironmentRequestDto },
    TContext
  >;
};

export type DeployTagToEnvironmentMutationResult = NonNullable<Awaited<ReturnType<typeof deployTagToEnvironment>>>;
export type DeployTagToEnvironmentMutationBody = DeployTagToEnvironmentRequestDto;
export type DeployTagToEnvironmentMutationError = unknown;

/**
 * @summary Deploy a tag to an environment
 */
export const useDeployTagToEnvironment = <
  TData = Awaited<ReturnType<typeof deployTagToEnvironment>>,
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: DeployTagToEnvironmentPathParameters; data: DeployTagToEnvironmentRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: DeployTagToEnvironmentPathParameters; data: DeployTagToEnvironmentRequestDto },
  TContext
> => {
  const mutationOptions = getDeployTagToEnvironmentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete a release candidate
 * @summary Delete a release candidate
 */
export const deleteReleaseCandidate = (
  { organization, project, application, id }: DeleteReleaseCandidatePathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/release-candidate/${encodeURIComponent(String(id))}/delete`,
      method: 'POST',
      signal,
    },
    options,
  );
};

export const getDeleteReleaseCandidateMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteReleaseCandidate>>,
  TError = DeleteReleaseCandidateDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { pathParams: DeleteReleaseCandidatePathParameters }, TContext>;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['deleteReleaseCandidate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReleaseCandidate>>,
    { pathParams: DeleteReleaseCandidatePathParameters }
  > = (props) => {
    const { pathParams } = props ?? {};

    return deleteReleaseCandidate(pathParams, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: DeleteReleaseCandidatePathParameters },
    TContext
  >;
};

export type DeleteReleaseCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReleaseCandidate>>>;

export type DeleteReleaseCandidateMutationError = DeleteReleaseCandidateDefault;

/**
 * @summary Delete a release candidate
 */
export const useDeleteReleaseCandidate = <
  TData = Awaited<ReturnType<typeof deleteReleaseCandidate>>,
  TError = DeleteReleaseCandidateDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { pathParams: DeleteReleaseCandidatePathParameters }, TContext>;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<TData, TError, { pathParams: DeleteReleaseCandidatePathParameters }, TContext> => {
  const mutationOptions = getDeleteReleaseCandidateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete an environment variable
 * @summary Delete an environment variable
 */
export const deleteEnvironmentVariable = (
  { organization, project, application, id }: DeleteEnvironmentVariablePathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/environment-variable/${encodeURIComponent(String(id))}/delete`,
      method: 'POST',
      signal,
    },
    options,
  );
};

export const getDeleteEnvironmentVariableMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteEnvironmentVariable>>,
  TError = DeleteEnvironmentVariableDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { pathParams: DeleteEnvironmentVariablePathParameters }, TContext>;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['deleteEnvironmentVariable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEnvironmentVariable>>,
    { pathParams: DeleteEnvironmentVariablePathParameters }
  > = (props) => {
    const { pathParams } = props ?? {};

    return deleteEnvironmentVariable(pathParams, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: DeleteEnvironmentVariablePathParameters },
    TContext
  >;
};

export type DeleteEnvironmentVariableMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEnvironmentVariable>>
>;

export type DeleteEnvironmentVariableMutationError = DeleteEnvironmentVariableDefault;

/**
 * @summary Delete an environment variable
 */
export const useDeleteEnvironmentVariable = <
  TData = Awaited<ReturnType<typeof deleteEnvironmentVariable>>,
  TError = DeleteEnvironmentVariableDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { pathParams: DeleteEnvironmentVariablePathParameters }, TContext>;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<TData, TError, { pathParams: DeleteEnvironmentVariablePathParameters }, TContext> => {
  const mutationOptions = getDeleteEnvironmentVariableMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Set the environment order
 * @summary Set the environment order
 */
export const setEnvironmentOrder = (
  { organization, project, application }: SetEnvironmentOrderPathParameters,
  setEnvironmentOrderBody: string[],
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/set-environment-order`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: setEnvironmentOrderBody,
      signal,
    },
    options,
  );
};

export const getSetEnvironmentOrderMutationOptions = <
  TData = Awaited<ReturnType<typeof setEnvironmentOrder>>,
  TError = SetEnvironmentOrderDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: SetEnvironmentOrderPathParameters; data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['setEnvironmentOrder'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setEnvironmentOrder>>,
    { pathParams: SetEnvironmentOrderPathParameters; data: string[] }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return setEnvironmentOrder(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: SetEnvironmentOrderPathParameters; data: string[] },
    TContext
  >;
};

export type SetEnvironmentOrderMutationResult = NonNullable<Awaited<ReturnType<typeof setEnvironmentOrder>>>;
export type SetEnvironmentOrderMutationBody = string[];
export type SetEnvironmentOrderMutationError = SetEnvironmentOrderDefault;

/**
 * @summary Set the environment order
 */
export const useSetEnvironmentOrder = <
  TData = Awaited<ReturnType<typeof setEnvironmentOrder>>,
  TError = SetEnvironmentOrderDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: SetEnvironmentOrderPathParameters; data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<TData, TError, { pathParams: SetEnvironmentOrderPathParameters; data: string[] }, TContext> => {
  const mutationOptions = getSetEnvironmentOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get the environment variable list for an environment
 * @summary Get the environment variable list for an environment
 */
export const getEnvironmentVariables = (
  { organization, project, application, environment }: GetEnvironmentVariablesPathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<EnvironmentVariableDto[]>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/${encodeURIComponent(String(environment))}/environment-variable-list`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetEnvironmentVariablesQueryKey = ({
  organization,
  project,
  application,
  environment,
}: GetEnvironmentVariablesPathParameters) => {
  return [`/v2/pipeline/${organization}/${project}/${application}/${environment}/environment-variable-list`] as const;
};

export const getGetEnvironmentVariablesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnvironmentVariables>>,
  TError = unknown,
>(
  { organization, project, application, environment }: GetEnvironmentVariablesPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getEnvironmentVariables>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEnvironmentVariablesQueryKey({ organization, project, application, environment });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnvironmentVariables>>> = ({ signal }) =>
    getEnvironmentVariables({ organization, project, application, environment }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && project && application && environment),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEnvironmentVariables>>, TError, TData> & { queryKey: QueryKey };
};

export type GetEnvironmentVariablesQueryResult = NonNullable<Awaited<ReturnType<typeof getEnvironmentVariables>>>;
export type GetEnvironmentVariablesQueryError = unknown;

/**
 * @summary Get the environment variable list for an environment
 */

export function useGetEnvironmentVariables<
  TData = Awaited<ReturnType<typeof getEnvironmentVariables>>,
  TError = unknown,
>(
  { organization, project, application, environment }: GetEnvironmentVariablesPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getEnvironmentVariables>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnvironmentVariablesQueryOptions(
    { organization, project, application, environment },
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetEnvironmentVariablesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnvironmentVariables>>,
  TError = unknown,
>(
  { organization, project, application, environment }: GetEnvironmentVariablesPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnvironmentVariables>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEnvironmentVariablesQueryKey({ organization, project, application, environment });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnvironmentVariables>>> = ({ signal }) =>
    getEnvironmentVariables({ organization, project, application, environment }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getEnvironmentVariables>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEnvironmentVariablesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEnvironmentVariables>>
>;
export type GetEnvironmentVariablesSuspenseQueryError = unknown;

/**
 * @summary Get the environment variable list for an environment
 */

export function useGetEnvironmentVariablesSuspense<
  TData = Awaited<ReturnType<typeof getEnvironmentVariables>>,
  TError = unknown,
>(
  { organization, project, application, environment }: GetEnvironmentVariablesPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnvironmentVariables>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnvironmentVariablesSuspenseQueryOptions(
    { organization, project, application, environment },
    options,
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set an environment variable
 * @summary Set an environment variable
 */
export const setEnvironmentVariable = (
  { organization, project, application, environment }: SetEnvironmentVariablePathParameters,
  setEnvironmentVariableRequestDto: SetEnvironmentVariableRequestDto,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/${encodeURIComponent(String(environment))}/environment-variable/set`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: setEnvironmentVariableRequestDto,
      signal,
    },
    options,
  );
};

export const getSetEnvironmentVariableMutationOptions = <
  TData = Awaited<ReturnType<typeof setEnvironmentVariable>>,
  TError = SetEnvironmentVariableDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: SetEnvironmentVariablePathParameters; data: SetEnvironmentVariableRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['setEnvironmentVariable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setEnvironmentVariable>>,
    { pathParams: SetEnvironmentVariablePathParameters; data: SetEnvironmentVariableRequestDto }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return setEnvironmentVariable(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: SetEnvironmentVariablePathParameters; data: SetEnvironmentVariableRequestDto },
    TContext
  >;
};

export type SetEnvironmentVariableMutationResult = NonNullable<Awaited<ReturnType<typeof setEnvironmentVariable>>>;
export type SetEnvironmentVariableMutationBody = SetEnvironmentVariableRequestDto;
export type SetEnvironmentVariableMutationError = SetEnvironmentVariableDefault;

/**
 * @summary Set an environment variable
 */
export const useSetEnvironmentVariable = <
  TData = Awaited<ReturnType<typeof setEnvironmentVariable>>,
  TError = SetEnvironmentVariableDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: SetEnvironmentVariablePathParameters; data: SetEnvironmentVariableRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: SetEnvironmentVariablePathParameters; data: SetEnvironmentVariableRequestDto },
  TContext
> => {
  const mutationOptions = getSetEnvironmentVariableMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Unset an environment variable
 * @summary Unset an environment variable
 */
export const unsetEnvironmentVariable = (
  { organization, project, application, environment }: UnsetEnvironmentVariablePathParameters,
  unsetEnvironmentVariableRequestDto: UnsetEnvironmentVariableRequestDto,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/${encodeURIComponent(String(environment))}/environment-variable/unset`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: unsetEnvironmentVariableRequestDto,
      signal,
    },
    options,
  );
};

export const getUnsetEnvironmentVariableMutationOptions = <
  TData = Awaited<ReturnType<typeof unsetEnvironmentVariable>>,
  TError = UnsetEnvironmentVariableDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: UnsetEnvironmentVariablePathParameters; data: UnsetEnvironmentVariableRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}) => {
  const mutationKey = ['unsetEnvironmentVariable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unsetEnvironmentVariable>>,
    { pathParams: UnsetEnvironmentVariablePathParameters; data: UnsetEnvironmentVariableRequestDto }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return unsetEnvironmentVariable(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { pathParams: UnsetEnvironmentVariablePathParameters; data: UnsetEnvironmentVariableRequestDto },
    TContext
  >;
};

export type UnsetEnvironmentVariableMutationResult = NonNullable<Awaited<ReturnType<typeof unsetEnvironmentVariable>>>;
export type UnsetEnvironmentVariableMutationBody = UnsetEnvironmentVariableRequestDto;
export type UnsetEnvironmentVariableMutationError = UnsetEnvironmentVariableDefault;

/**
 * @summary Unset an environment variable
 */
export const useUnsetEnvironmentVariable = <
  TData = Awaited<ReturnType<typeof unsetEnvironmentVariable>>,
  TError = UnsetEnvironmentVariableDefault,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { pathParams: UnsetEnvironmentVariablePathParameters; data: UnsetEnvironmentVariableRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof client>;
}): UseMutationResult<
  TData,
  TError,
  { pathParams: UnsetEnvironmentVariablePathParameters; data: UnsetEnvironmentVariableRequestDto },
  TContext
> => {
  const mutationOptions = getUnsetEnvironmentVariableMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get the environment variables by remote host
 * @summary Get the environment variables by remote host
 */
export const getEnvVarsByRemoteHost = (
  params: GetEnvVarsByRemoteHostParams,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<GetEnvVarsByRemoteHost200>(
    { url: `/v2/pipeline/environment-variables-by-remote-host`, method: 'GET', params, signal },
    options,
  );
};

export const getGetEnvVarsByRemoteHostQueryKey = (params: GetEnvVarsByRemoteHostParams) => {
  return [`/v2/pipeline/environment-variables-by-remote-host`, ...(params ? [params] : [])] as const;
};

export const getGetEnvVarsByRemoteHostQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>,
  TError = unknown,
>(
  params: GetEnvVarsByRemoteHostParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEnvVarsByRemoteHostQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>> = ({ signal }) =>
    getEnvVarsByRemoteHost(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEnvVarsByRemoteHostQueryResult = NonNullable<Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>>;
export type GetEnvVarsByRemoteHostQueryError = unknown;

/**
 * @summary Get the environment variables by remote host
 */

export function useGetEnvVarsByRemoteHost<TData = Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>, TError = unknown>(
  params: GetEnvVarsByRemoteHostParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnvVarsByRemoteHostQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetEnvVarsByRemoteHostSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>,
  TError = unknown,
>(
  params: GetEnvVarsByRemoteHostParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEnvVarsByRemoteHostQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>> = ({ signal }) =>
    getEnvVarsByRemoteHost(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEnvVarsByRemoteHostSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>>;
export type GetEnvVarsByRemoteHostSuspenseQueryError = unknown;

/**
 * @summary Get the environment variables by remote host
 */

export function useGetEnvVarsByRemoteHostSuspense<
  TData = Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>,
  TError = unknown,
>(
  params: GetEnvVarsByRemoteHostParams,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnvVarsByRemoteHost>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnvVarsByRemoteHostSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the environment variable history for an environment
 * @summary Get the environment variable history for an environment
 */
export const getEnvironmentVariableHistory = (
  { organization, project, application, environment }: GetEnvironmentVariableHistoryPathParameters,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal,
) => {
  return client<void>(
    {
      url: `/v2/pipeline/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(project))}/${encodeURIComponent(String(application))}/${encodeURIComponent(String(environment))}/environment-variable-history`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetEnvironmentVariableHistoryQueryKey = ({
  organization,
  project,
  application,
  environment,
}: GetEnvironmentVariableHistoryPathParameters) => {
  return [
    `/v2/pipeline/${organization}/${project}/${application}/${environment}/environment-variable-history`,
  ] as const;
};

export const getGetEnvironmentVariableHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnvironmentVariableHistory>>,
  TError = GetEnvironmentVariableHistoryDefault,
>(
  { organization, project, application, environment }: GetEnvironmentVariableHistoryPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getEnvironmentVariableHistory>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEnvironmentVariableHistoryQueryKey({ organization, project, application, environment });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnvironmentVariableHistory>>> = ({ signal }) =>
    getEnvironmentVariableHistory({ organization, project, application, environment }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && project && application && environment),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEnvironmentVariableHistory>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetEnvironmentVariableHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEnvironmentVariableHistory>>
>;
export type GetEnvironmentVariableHistoryQueryError = GetEnvironmentVariableHistoryDefault;

/**
 * @summary Get the environment variable history for an environment
 */

export function useGetEnvironmentVariableHistory<
  TData = Awaited<ReturnType<typeof getEnvironmentVariableHistory>>,
  TError = GetEnvironmentVariableHistoryDefault,
>(
  { organization, project, application, environment }: GetEnvironmentVariableHistoryPathParameters,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getEnvironmentVariableHistory>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnvironmentVariableHistoryQueryOptions(
    { organization, project, application, environment },
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetEnvironmentVariableHistorySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnvironmentVariableHistory>>,
  TError = GetEnvironmentVariableHistoryDefault,
>(
  { organization, project, application, environment }: GetEnvironmentVariableHistoryPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnvironmentVariableHistory>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEnvironmentVariableHistoryQueryKey({ organization, project, application, environment });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnvironmentVariableHistory>>> = ({ signal }) =>
    getEnvironmentVariableHistory({ organization, project, application, environment }, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getEnvironmentVariableHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEnvironmentVariableHistorySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEnvironmentVariableHistory>>
>;
export type GetEnvironmentVariableHistorySuspenseQueryError = GetEnvironmentVariableHistoryDefault;

/**
 * @summary Get the environment variable history for an environment
 */

export function useGetEnvironmentVariableHistorySuspense<
  TData = Awaited<ReturnType<typeof getEnvironmentVariableHistory>>,
  TError = GetEnvironmentVariableHistoryDefault,
>(
  { organization, project, application, environment }: GetEnvironmentVariableHistoryPathParameters,
  options?: {
    query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEnvironmentVariableHistory>>, TError, TData>;
    request?: SecondParameter<typeof client>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnvironmentVariableHistorySuspenseQueryOptions(
    { organization, project, application, environment },
    options,
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const checkDevopsFeature = (options?: SecondParameter<typeof client>, signal?: AbortSignal) => {
  return client<boolean>({ url: `/v2/pipeline/check-devops-feature`, method: 'GET', signal }, options);
};

export const getCheckDevopsFeatureQueryKey = () => {
  return [`/v2/pipeline/check-devops-feature`] as const;
};

export const getCheckDevopsFeatureQueryOptions = <
  TData = Awaited<ReturnType<typeof checkDevopsFeature>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof checkDevopsFeature>>, TError, TData>;
  request?: SecondParameter<typeof client>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckDevopsFeatureQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkDevopsFeature>>> = ({ signal }) =>
    checkDevopsFeature(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checkDevopsFeature>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckDevopsFeatureQueryResult = NonNullable<Awaited<ReturnType<typeof checkDevopsFeature>>>;
export type CheckDevopsFeatureQueryError = unknown;

export function useCheckDevopsFeature<
  TData = Awaited<ReturnType<typeof checkDevopsFeature>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof checkDevopsFeature>>, TError, TData>;
  request?: SecondParameter<typeof client>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCheckDevopsFeatureQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCheckDevopsFeatureSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof checkDevopsFeature>>,
  TError = unknown,
>(options?: {
  query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof checkDevopsFeature>>, TError, TData>;
  request?: SecondParameter<typeof client>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckDevopsFeatureQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkDevopsFeature>>> = ({ signal }) =>
    checkDevopsFeature(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof checkDevopsFeature>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckDevopsFeatureSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof checkDevopsFeature>>>;
export type CheckDevopsFeatureSuspenseQueryError = unknown;

export function useCheckDevopsFeatureSuspense<
  TData = Awaited<ReturnType<typeof checkDevopsFeature>>,
  TError = unknown,
>(options?: {
  query?: UseSuspenseQueryOptions<Awaited<ReturnType<typeof checkDevopsFeature>>, TError, TData>;
  request?: SecondParameter<typeof client>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCheckDevopsFeatureSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
